export const ACTIVITY_TEMPLATE_TYPES = [
  'Games',
  'Worksheets',
  'Manipulatives',
  'Tools'
];

// No migration needed: older records have no type.
export const getActivityTemplateType = template => template.type || 'Games';

export const filterTemplatesByType = (templates, type) =>
  templates.filter(template => getActivityTemplateType(template) === type);

// Keep templates assigned to additional admin-list types reachable in Make.
export const getAvailableActivityTemplateTypes = (templates, configuredTypes = []) =>
  Array.from(new Set([
    ...(configuredTypes.length ? configuredTypes : ACTIVITY_TEMPLATE_TYPES),
    ...templates.map(getActivityTemplateType)
  ]));
